/** Naslov i opis ispod scene zaboravljene lozinke. */
export const FORGOT_PASSWORD_INTRO_TEXT = {
  title: "Nova lozinka u par koraka",
  description: "Poslat ćemo vam poveznicu na email, a novu lozinku postavljate sami.",
};

/** Primjer emaila s poveznicom za promjenu lozinke. */
export const FORGOT_PASSWORD_INTRO_EMAIL = {
  sender: "Orytron",
  recipient: "marko.horvat@orytron.com",
  subject: "Promjena lozinke",
  action: "Postavi novu lozinku",
};

/** Broj točkica u skrivenom polju nove lozinke. */
export const FORGOT_PASSWORD_INTRO_MASK_LENGTH = 10;
